module.exports = __webpack_public_path__ + "static/media/trophy.c603bea5.svg";